/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Registration_TitleInputs */

const en_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Registration and Account`)
};

const de_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Registrierung und Konto`)
};

const fr_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Inscription et compte`)
};

const es_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Registro y cuenta`)
};

const it_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Registrazione e account`)
};

const nl_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Registratie en account`)
};

const pl_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Rejestracja i konto`)
};

const fi_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Rekisteröityminen ja tili`)
};

const da_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Registrering og konto`)
};

const sv_agb_registration_title = /** @type {(inputs: Agb_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Registrering och konto`)
};

/**
* | output |
* | --- |
* | "3. Registration and Account" |
*
* @param {Agb_Registration_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_registration_title = /** @type {((inputs?: Agb_Registration_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Registration_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_registration_title(inputs)
	if (locale === "fr") return fr_agb_registration_title(inputs)
	if (locale === "es") return es_agb_registration_title(inputs)
	if (locale === "it") return it_agb_registration_title(inputs)
	if (locale === "nl") return nl_agb_registration_title(inputs)
	if (locale === "pl") return pl_agb_registration_title(inputs)
	if (locale === "fi") return fi_agb_registration_title(inputs)
	if (locale === "da") return da_agb_registration_title(inputs)
	if (locale === "sv") return sv_agb_registration_title(inputs)
	return en_agb_registration_title(inputs)
});